import * as z from 'zod';
import { ApiExceptions, VarietyPropertyName } from './api-untyped-exceptions';
function makeErrorSchema(response) {
    return z.object({
        // TODO: error wasn't properly branded because the interceptors are called before branding.
        // [VarietyPropertyName]: z.literal(ApiExceptions.Error),
        request: z.object({
            response: z.string(),
        }),
        response: response.optional(),
        status: z.number(),
        message: z.string(),
    });
}
export function makeApiError(schema, obj) {
    // @ts-expect-error I don't know how to write the correct types
    return {
        ...obj,
        [VarietyPropertyName]: ApiExceptions.Error,
    };
}
export function isApiError(arg, response) {
    return makeErrorSchema(response).safeParse(arg).success;
}
/**
 * Force cast error to ApiError without any validation.
 * @param error - any target
 * @param response
 * @deprecated Validate error type with `isApiError` instead.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function unsafeCastToApiError(error, response) {
    return error;
}
const CancelSchema = z.object({
    [VarietyPropertyName]: z.literal(ApiExceptions.Cancel),
});
export function makeApiCancel() {
    return {
        [VarietyPropertyName]: ApiExceptions.Cancel,
    };
}
export function isApiCancel(arg) {
    return CancelSchema.safeParse(arg).success;
}
